import { render, staticRenderFns } from "./FullScreenPrintCard.vue?vue&type=template&id=dfce21b2&scoped=true&"
import script from "./FullScreenPrintCard.vue?vue&type=script&lang=js&"
export * from "./FullScreenPrintCard.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenPrintCard.vue?vue&type=style&index=0&id=dfce21b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfce21b2",
  null
  
)

export default component.exports